import React, { useCallback, useEffect, useState } from 'react';
import Helmet from 'react-helmet';

import './GuestHomePage.css';

import { observer } from 'mobx-react';

import CurrentLiveAnchors from '../../components/LiveEvents/CurrentLiveAnchors';
import SubscribeCTAButton from '../../components/GuestHomePageComponents/SubscribeCTAButton';
import GuestHomeFeaturedSection from '../../components/GuestHomePageComponents/GuestHomeFeaturedSection';
import GuestHomeShopSection from '../../components/GuestHomePageComponents/GuestHomeShopSection';
import GuestCarouselContent from '../../components/GuestHomePageComponents/GuestCarouselContent';
import Announcements from '../../components/GuestHomePageComponents/Announcements';
import AnchorsCarousel from '../../components/GuestHomePageComponents/AnchorsCarousel';
import Adds from '../../components/Adds/Adds';
import AnchorStore from '../../store/AnchorStore';

import styles from './css/GuestHomePage.module.css';
import NewUserSignup from './NewUserSignup';
import CheckEmailMessage from './CheckEmailMessage';
import { mainCarouselContent } from '../../components/GuestHomePageComponents/CarouselContent';


function GuestHomePage(props) {
  const {
    user,
    activeCampaign,
    allActiveCampaigns,
  } = props;
  const [shouldShowCheckEmailMessage, setShouldShowCheckEmailMessage] = useState(false);

  useEffect(() => {
    AnchorStore.setAnchorsWithFanzone();
  }, []);

  const dismissCheckEmailMessage = useCallback(() => {
    setShouldShowCheckEmailMessage(false);
  }, [setShouldShowCheckEmailMessage]);

  const anchorsToShow = ['current-anchors'];

  if (shouldShowCheckEmailMessage && !user.authenticated) {
    return (
      <CheckEmailMessage dismissMessage={dismissCheckEmailMessage} />
    );
  }

  return (
    <div id="guest-page">
      <Helmet>
        <title>Home | Naked News</title>
        <meta name="description" content={mainCarouselContent.main} />
      </Helmet>
      <div className="container unblurred-container">
        <div className="main-carousel-home">
          <GuestCarouselContent
            activeCampaign={activeCampaign}
            allActiveCampaigns={allActiveCampaigns}
            user={user}
          />
          <div className="carousel-container-red" id="red-background" />
        </div>
        <NewUserSignup
          setShouldShowCheckEmailMessage={setShouldShowCheckEmailMessage}
          user={user} />
        <CurrentLiveAnchors />
      </div>
      <div className="anchors-section container">
        <div className="anchors-section-header">
          <div className="header-wrapper">
            <div className={styles.headerLine} />
            <h2 className={styles.headerText}>Meet the Naked News Anchors</h2>
            <div className={styles.headerLine} />
          </div>
        </div>
        <AnchorsCarousel anchorsToShow={anchorsToShow} isGuestHomePage={true} />
      </div>
      <div className="container">
        <div className={styles.guestSectionInfo}>
          <h1 className={styles.headerText}>You&apos;ve never seen anything like Naked News!</h1>
          <p className={styles.description}>
            {mainCarouselContent.callToAction}
          </p>
          <p className={styles.description}>
            Become a member today and enjoy our naughty segments that will keep you hooked and craving for more. There&apos;s no room for boredom in our program, as each day you'll receive a dose of Naked News!
          </p>
          <SubscribeCTAButton title="MEMBER" topText="BECOME A" />
        </div>
      </div>
      <Announcements />
      <div className="container featured-section-container">
        <GuestHomeFeaturedSection type="featured" />
      </div>
      <Adds isAnchorPageAd={false} />
      <div className="anchors-section container">
        <div className="anchors-section-header">
          <div className="header-wrapper">
            <div className={styles.headerLine} />
            <h1 className={styles.headerText}>Shop Our Latest Products</h1>
            <div className={styles.headerLine} />
          </div>
        </div>
        <GuestHomeShopSection />
      </div>
    </div>
  );
}

export default observer(GuestHomePage);
